import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Footer.css"; 
import companyLogo from "../assets/logo.png"; 
import { message } from "antd"; // Import Ant Design message component
import axiosInstance from "./axiosInstance";
import { API } from "../API";

const FOOTER_TEXT = {
  icpNumber: "闽ICP备11001014号-3",
};
const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post(`${API.ORDER}/order/subscriber`, { 
        clientEmail: email,
        clientTel: "000-0000-0000",
        orderDetail: "Subscribe to newsletter",
      });
      message.success("Subscribed successfully!");
      setEmail("");
    } catch (error) {
      console.error("Error subscribing:", error);
      message.error("Subscription failed. Please try again.");
    }
  }
  
  return (
    <footer className="footerContainer">
      <div className="footerSection companyInfo">
        <img src={companyLogo} alt="Company Logo" className="companyInfoUp companyLogo" />
        <div className="companyInfoDown">
          <div className="companyInfoLeft"> 
              <p><b>Address:</b> No.78, Xiadian Road, Shuitou Town, Quanzhou City, Fujian Province, China</p>
          </div>
          <div className="companyInfoRight">
            <p> <b>Tel:</b> +86 183 5971 2857</p>
            <p> <b>Whatsapp:</b> +86 18359712857</p>
            <p> <b>Email:</b> elise@nw-stone.com</p>
          </div>
        </div>
      </div>

      <div className="footerSection guideSection">
        <h3>Guide</h3>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/Product">Products</Link></li>
          <li><Link to="/Blog">Blog</Link></li>
          <li><Link to="/AboutUs">About Us</Link></li>
          <li><Link to="/GetInTouch">Get In Touch</Link></li>
        </ul>
      </div>

      <div className="footerSection newsletterSection">
        <h3 className="newsletterTitle">NEWSLETTER</h3>
        <hr className="newsletterDivider" />
        <p className="newsletterText">Stay tuned for the latest company news.</p>
        <form className="newsletterForm" onSubmit={handleSubscribe}>
          <input
            type="email"
            placeholder="Your Email ..."
            className="newsletterInput"
            required
            value={ email }
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" className="newsletterButton">
            SUBSCRIBE <i className="fas fa-paper-plane" style={{ marginLeft: 6 }}></i>
          </button>
        </form>
      </div>
    <div className="footerRegistration">
        <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
        >
        {FOOTER_TEXT.icpNumber}
        </a>
    </div>
    </footer>
  );
};

export default Footer;